import { Link } from 'react-router-dom';
import { contentList } from '@/mocks/content';

export default function UpdateRanking() {
  const latest = [...contentList]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              中文字幕更新排行
            </h2>
            <p className="text-foreground-600 text-sm">实时追踪日韩剧中文字幕最新更新动态</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {latest.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                <span className={`font-heading font-bold text-sm ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-500'
                }`}>
                  {index + 1}
                </span>
              </div>
              <div className="flex-shrink-0 w-16 h-20 rounded-lg overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-foreground-500">{item.country}</span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                    {item.categoryLabel}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                    <span className="text-xs font-semibold text-foreground-800">{item.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-500">|</span>
                  <span className="text-xs text-foreground-500 truncate">{item.updateSpeed}</span>
                </div>
              </div>
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-500"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}